import script from "./LoaUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaUpload.vue?vue&type=script&setup=true&lang=js"

import "./LoaUpload.vue?vue&type=style&index=0&id=d3b46364&lang=css"

const __exports__ = script;

export default __exports__